<!-- Chart option -->
<div
  echarts
  class="dashboard-chart"
  [ngStyle]="{ height: cardHeight || '32rem' }"
  [options]="chartOptions"
  [title]="reportTitle"></div>
<!-- TODO: Add KPI option -->
